import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { Kintai_Summary_Info } from "../classes/Kintai_Summary_Info_class";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as commonFnc from '../common/commonFnc';
import {GlobalContext} from '../globalState'


// name: ApprovalUserListTable
// summary: 【承認者用画面】承認対象の職員一覧を表示する。
// prop: kintaiSummaryInfos 勤怠承認サマリーの一覧
// prop: Department_msts 部署情報
// prop: Users ユーザ情報
// prop: setKintai_bscs 勤怠情報のセッター


const ApprovalUserListTable = (props) =>{
    
    // 01_props
    const {
        kintaiSummaryInfos, 
        Department_msts, 
        Users, 
        setKintai_bscs, 
        setShiftStartDay, 
        serchCondition, 
        setDisplay_user_info,
        allUser_Kintai_bscs,
        loading,
    } = props;
    const history = useHistory();
    const limits = useContext(GlobalContext).limits;
    const lastday = new Date(serchCondition.target_date_to).getDate();

    
    const Env_msts = useContext(GlobalContext).Env_msts;
    const custom1 = Env_msts.find(p=>p.env_key==="CUSTOM1");
    const custom2 = Env_msts.find(p=>p.env_key==="CUSTOM2");
    const custom3 = Env_msts.find(p=>p.env_key==="CUSTOM3");
    const custom4 = Env_msts.find(p=>p.env_key==="CUSTOM4");
    const custom5 = Env_msts.find(p=>p.env_key==="CUSTOM5");

    
    var userNameHash = {};
    Users.map((user) => (
        userNameHash[user.user_id] = user.first_name + " " + user.second_name
    ));

    // 02_useState
    const [kintaiSummaryInfos_view, setKintaiSummaryInfos_view] = useState([]);
    const [sortKey, setSortKey] = useState('department_name');
    const [sortOrder, setSortOrder] = useState('asc'); // 'asc' または 'desc'

    useEffect(()=>{
        let tmp_kintaiSummaryInfos_view = [];

        kintaiSummaryInfos.map((kintaiSummaryInfo, index) => {
            const tmp_user = Users.find(item => item.user_id === kintaiSummaryInfo._id);
            
            if(tmp_user){

                // 検索条件が設定されていればそれ以外をスキップ 
                if(serchCondition.target_deptgr_cd.length > 1 && tmp_user.organization_cd !== serchCondition.target_deptgr_cd) return;
                if(serchCondition.target_dept_cd.length > 1 && tmp_user.department_cd !== serchCondition.target_dept_cd) return;
                if(serchCondition.target_user_id.length > 1 && tmp_user.user_id !== serchCondition.target_user_id) return;
                if(serchCondition.target_user_name.length > 1 && userNameHash[tmp_user.user_id]?.indexOf(serchCondition.target_user_name)===-1) return;


                const tmp_dept = Department_msts.find(item => item.department_cd === tmp_user?.department_cd);
                const tmp_deptgr = Department_msts.find(item => item.department_cd === tmp_dept?.highly_department_cd);
                const tmp_kintai_bscs = allUser_Kintai_bscs.filter(item=>item.user_id === kintaiSummaryInfo._id);
    
                tmp_kintaiSummaryInfos_view.push(new Kintai_Summary_Info(kintaiSummaryInfo, tmp_user, tmp_dept, tmp_deptgr, Users, tmp_kintai_bscs));
            }
        });


        setKintaiSummaryInfos_view(tmp_kintaiSummaryInfos_view);
    },[kintaiSummaryInfos])

    // 03_独自関数(eventHandlerなど)

    const handlerClickNameButton = async (Kintai_bsc) => {
        
        // 勤怠一覧を初期化。遷移先で再取得
        setKintai_bscs([]);   

        let tmp_user = Users.find(item => item.user_id === Kintai_bsc.user_id);
        setDisplay_user_info(tmp_user);

        var d = new Date(serchCondition.target_date_from);
        setShiftStartDay(d);    

        history.push('/Kintai');

    }

    const handleOnClickSortButton = (keyName) => {
        if (sortKey === keyName) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortKey(keyName);
            setSortOrder('asc');
        }
    }

    const getSortIcon = (keyName) => {
        if (sortKey === keyName) {
            return <span style={style.sortIcon}>{sortOrder === 'asc' ? '▲' : '▼'}</span>;
        }
        return <span style={style.sortIcon}>⇅</span>;
    };

    const STRING_SORT_KEYS = [
        'organization_name',
        'department_name',
        'user_id',
        'user_name',
    ];

    const compareRows = (a, b) => {
        const aVal = a[sortKey];
        const bVal = b[sortKey];
        let comparison = 0;

        if (STRING_SORT_KEYS.includes(sortKey)) {
            comparison = String(aVal ?? '').localeCompare(String(bVal ?? ''), 'ja');
        } else {
            comparison = (Number(aVal) || 0) - (Number(bVal) || 0);
        }

        return sortOrder === 'desc' ? -comparison : comparison;
    };

    const getSortableHeaderStyle = (keyName, extraStyle = {}) => ({
        ...style.tableCellBase,
        ...style.sortableHeaderCell,
        ...extraStyle,
        borderBottom: sortKey === keyName ? '2px solid #1976d2' : '',
    });

    const style = {
        tableCellBase:{
            fontSize:'0.8rem',
            padding:'3px',
            "& .MuiTableCell-root": { padding: "8px" }
        },
        sortableHeaderCell: {
            cursor: 'pointer',
            userSelect: 'none',
            transition: 'all 0.2s ease',
        },
        sortIcon: {
            marginLeft: '4px',
            fontSize: '0.7rem',
            opacity: 0.7,
            display: 'inline-block',
        },
    }

    return (
        <>
            {loading ? <div class="loader">Loading...</div> :
            <TableContainer component={Paper} style={{ maxHeight: '65vh'}}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={getSortableHeaderStyle('organization_name', {minWidth:100})} onClick={()=>handleOnClickSortButton('organization_name')}>施設名{getSortIcon('organization_name')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('department_name', {minWidth:100})} onClick={()=>handleOnClickSortButton('department_name')}>部署名{getSortIcon('department_name')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('user_id')} onClick={()=>handleOnClickSortButton('user_id')}>職員番号{getSortIcon('user_id')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('user_name', {minWidth:100})} onClick={()=>handleOnClickSortButton('user_name')}>氏名{getSortIcon('user_name')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('count_work_days')} onClick={()=>handleOnClickSortButton('count_work_days')}>出勤日数{getSortIcon('count_work_days')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_work_time')} onClick={()=>handleOnClickSortButton('sum_work_time')}>時間{getSortIcon('sum_work_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_rest_time')} onClick={()=>handleOnClickSortButton('sum_rest_time')}>休憩{getSortIcon('sum_rest_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_over_time')} onClick={()=>handleOnClickSortButton('sum_over_time')}>時間外{getSortIcon('sum_over_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_midnight_over_time')} onClick={()=>handleOnClickSortButton('sum_midnight_over_time')}>深夜{getSortIcon('sum_midnight_over_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_behind_time')} onClick={()=>handleOnClickSortButton('sum_behind_time')}>遅刻{getSortIcon('sum_behind_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_early_time')} onClick={()=>handleOnClickSortButton('sum_early_time')}>早退{getSortIcon('sum_early_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_out_time')} onClick={()=>handleOnClickSortButton('sum_out_time')}>外出{getSortIcon('sum_out_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_training_time')} onClick={()=>handleOnClickSortButton('sum_training_time')}>業務外{getSortIcon('sum_training_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_public_holiday_time')} onClick={()=>handleOnClickSortButton('sum_public_holiday_time')}>公休{getSortIcon('sum_public_holiday_time')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('sum_paid_holiday_time')} onClick={()=>handleOnClickSortButton('sum_paid_holiday_time')}>有給{getSortIcon('sum_paid_holiday_time')}</TableCell>
                            {custom1?.log_del_flg ? "" : <TableCell align="center" style={getSortableHeaderStyle('sum_custom1')} onClick={()=>handleOnClickSortButton('sum_custom1')}>{custom1?.env_value.substr( 0, 4 )}{getSortIcon('sum_custom1')}</TableCell>}
                            {custom2?.log_del_flg ? "" : <TableCell align="center" style={getSortableHeaderStyle('sum_custom2')} onClick={()=>handleOnClickSortButton('sum_custom2')}>{custom2?.env_value.substr( 0, 4 )}{getSortIcon('sum_custom2')}</TableCell>}
                            {custom3?.log_del_flg ? "" : <TableCell align="center" style={getSortableHeaderStyle('sum_custom3')} onClick={()=>handleOnClickSortButton('sum_custom3')}>{custom3?.env_value.substr( 0, 4 )}{getSortIcon('sum_custom3')}</TableCell>}
                            {custom4?.log_del_flg ? "" : <TableCell align="center" style={getSortableHeaderStyle('sum_custom4')} onClick={()=>handleOnClickSortButton('sum_custom4')}>{custom4?.env_value.substr( 0, 4 )}{getSortIcon('sum_custom4')}</TableCell>}
                            {custom5?.log_del_flg ? "" : <TableCell align="center" style={getSortableHeaderStyle('sum_custom5')} onClick={()=>handleOnClickSortButton('sum_custom5')}>{custom5?.env_value.substr( 0, 4 )}{getSortIcon('sum_custom5')}</TableCell>}
                            <TableCell align="center" style={getSortableHeaderStyle('count_before', {"borderLeft":"solid 1px lightgray"})} onClick={()=>handleOnClickSortButton('count_before')}>申請前{getSortIcon('count_before')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('count_wait1')} onClick={()=>handleOnClickSortButton('count_wait1')}>一次待ち{getSortIcon('count_wait1')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('count_wait2')} onClick={()=>handleOnClickSortButton('count_wait2')}>二次待ち{getSortIcon('count_wait2')}</TableCell>
                            <TableCell align="center" style={getSortableHeaderStyle('count_commit')} onClick={()=>handleOnClickSortButton('count_commit')}>確定{getSortIcon('count_commit')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {[...kintaiSummaryInfos_view].sort(compareRows).map((kintaiSummaryInfo_view,index)=>(
                            
                            <TableRow key={index}>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.organization_name}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.department_name}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} ><Button onClick={()=>handlerClickNameButton(kintaiSummaryInfo_view)}><span className="link">{kintaiSummaryInfo_view.user_id}</span></Button></TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.user_name}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.count_work_days}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_work_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_rest_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}}  className={kintaiSummaryInfo_view.sum_over_time>limits["LIMIT_OVER_TIME"]?"alert":""}>{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_over_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_midnight_over_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_behind_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_early_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_out_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{commonFnc.getHHmm(kintaiSummaryInfo_view.sum_training_time)}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.sum_public_holiday_time/8}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.sum_paid_holiday_time/8}</TableCell>
                                {custom1?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.sum_custom1 ? commonFnc.getHHmm(kintaiSummaryInfo_view.sum_custom1) : ""}</TableCell>}
                                {custom2?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.sum_custom2 ? commonFnc.getHHmm(kintaiSummaryInfo_view.sum_custom2) : ""}</TableCell>}
                                {custom3?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.sum_custom3 ? commonFnc.getHHmm(kintaiSummaryInfo_view.sum_custom3) : ""}</TableCell>}
                                {custom4?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.sum_custom4 ? commonFnc.getHHmm(kintaiSummaryInfo_view.sum_custom4) : ""}</TableCell>}
                                {custom5?.log_del_flg ? "" : <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.sum_custom5 ? commonFnc.getHHmm(kintaiSummaryInfo_view.sum_custom5) : ""}</TableCell>}
                                <TableCell align="center" style={{...style.tableCellBase, "borderLeft":"solid 1px lightgray"}} >{kintaiSummaryInfo_view.count_before}/{lastday}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.count_wait1}/{lastday}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}} >{kintaiSummaryInfo_view.count_wait2}/{lastday}</TableCell>
                                <TableCell align="center" style={{...style.tableCellBase}}  className={kintaiSummaryInfo_view.count_commit!==lastday?"commit_error":"commit_completed"}>{kintaiSummaryInfo_view.count_commit}/{lastday}</TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </>
    );
}
export default ApprovalUserListTable;